import { MONITORING_LLM_LABELS } from "../../../utils/constant";
import { extractDomain } from "../../../utils/helpers";
import { getColorCode } from "../../../utils/monitoring-helpers";
import Tooltip from "@mui/material/Tooltip";
import classes from "./SummaryCard.module.css";
import { ENTITY_LABELS } from "../../../utils/labelMapping";

export const CardTable = ({ llms = {}, llmDomains, compLlms }) => {

  const maxSentimentPerLlm = {};
  Object.keys(llms).forEach((llmName) => {
    const sentimentValues = [
      llms[llmName]?.avg_brand_favorability_score || 0
    ];

    // Safely extract sentiment values from competitors
    if (compLlms && typeof compLlms === 'object') {
      Object.values(compLlms).forEach((competitorData) => {
        if (competitorData && typeof competitorData === 'object' && competitorData.llms && competitorData.llms[llmName]) {
          sentimentValues.push(competitorData.llms[llmName]?.avg_brand_favorability_score || 0);
        }
      });
    }

    maxSentimentPerLlm[llmName] = sentimentValues.length > 0 ? Math.max(...sentimentValues) : 0;
  });

  console.log("Max Sentiment Per LLM:", maxSentimentPerLlm, compLlms);

  return (
    <div className="idReSe">
      <table className="table-sm w-100 text-center table-borderless">
        <thead>
          <tr style={{ color: "#7A7A7A", fontWeight: 500, lineHeight: "18px" }}>
            <th scope="col"></th>
            <th scope="col">Index</th>
            <th scope="col">{ENTITY_LABELS.rank}</th>
            <th scope="col">Sentiment</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(llms).map((llmName) => {
            const data = llms[llmName];
            const indexValue = Number(data?.avg_brand_index_score || 0);
            const visibilityValue = Number(data?.avg_brand_reach_score || 0);
            const sentimentValue = Number(data?.avg_brand_favorability_score || 0);

            // Get max sentiment for current LLM comparing main brand with competitors
            const maxSentimentForLlm = maxSentimentPerLlm[llmName] || sentimentValue;

            return (
              <tr
                style={{
                  color: "#7A7A7A",
                  fontWeight: 500,
                  lineHeight: "18px",
                }}
                key={llmName}
              >
                <th style={{ display: "flex", alignItems: "center" }} scope="row">
                  <img
                    className={
                      llmName !== "llm-web" ? classes.logo : classes.logo2
                    }
                    src={
                      llmName === "llm-web"
                        ? "/menu.png"
                        : extractDomain(llmDomains?.[llmName]) === "google.com"
                          ? "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg"
                          : `https://img.logo.dev/${extractDomain(
                            llmDomains?.[llmName]
                          )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`
                    }
                    alt=""
                  />
                  &nbsp; &nbsp;
                  <span>{MONITORING_LLM_LABELS?.[llmName] || llmName}</span>
                </th>

                <td
                  style={{ color: getColorCode(indexValue, undefined, 'RBI') }}
                >
                  {indexValue.toFixed(0)}
                </td>
                <td
                  style={{ color: getColorCode(visibilityValue, undefined, 'visibility') }}
                >
                  {visibilityValue.toFixed(0)}
                </td>
                <td
                  style={{ color: getColorCode(sentimentValue, maxSentimentForLlm) }}
                >
                  <Tooltip
                    title={
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ fontSize: '12px' }} ><strong>Competitors Sentiment Score</strong></div>
                        {compLlms && Object.entries(compLlms).map(([compName, compData]) => {
                          const compSentiment = compData?.llms?.[llmName]?.avg_brand_favorability_score;
                          if (compSentiment !== undefined && compSentiment !== null) {
                            return (
                              <div key={compName}>
                                <strong>{compName}:</strong> {Number(compSentiment).toFixed(0)}
                              </div>
                            );
                          }
                          return null;
                        })}
                      </div>
                    }
                    placement="top"
                    arrow
                  >
                    <span style={{ cursor: 'pointer' }}>{sentimentValue.toFixed(0)}</span>
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
